import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/shared/lib/cn'
import type { ReactNode, ElementType } from 'react'

const cardVariants = cva(
  'p-5 rounded-xl flex flex-col relative group transition-colors duration-300 h-full',
  {
    variants: {
      variant: {
        default: 'bg-[#111111] border border-white/5 hover:border-white/10',
        elevated: 'bg-[#161616] border border-white/10',
        inner: 'bg-white/5 border border-white/5',
        ghost: 'bg-transparent',
      },
      size: {
        default: 'p-5',
        sm: 'p-3',
        lg: 'p-6',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
)

export interface CardProps extends VariantProps<typeof cardVariants> {
  children: ReactNode
  className?: string
  title?: string
  icon?: ElementType
  action?: ReactNode
}

export function Card({
  children,
  className,
  variant,
  size,
  title,
  icon: Icon,
  action,
}: CardProps) {
  return (
    <div className={cn(cardVariants({ variant, size }), className)}>
      {(title || Icon) && (
        <div className="flex justify-between items-center mb-4 flex-shrink-0">
          <div className="flex items-center gap-2">
            {Icon && <Icon size={16} className="text-white/50" />}
            {title && (
              <span className="text-xs font-medium uppercase tracking-wider text-white/50">
                {title}
              </span>
            )}
          </div>
          {action && (
            <div className="card-action-area opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity text-white/50 hover:text-white z-10">
              {action}
            </div>
          )}
        </div>
      )}
      <div className="flex-1 min-h-0 overflow-hidden flex flex-col">
        {children}
      </div>
    </div>
  )
}

